import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { EncoderProfiles } from '@studio/types';

export const root = {
  [HTTP_METHODS.GET]: {
    method: HTTP_METHODS.GET,
    response: {} as EncoderProfiles.Get.Options,
    url: `${CENTRAL_API_V3}/customers/@customerId/encoderprofiles/options`,
  },
};
